import "./card-slider/card-slider";
import "./post-slider/post-slider";
import "./quote-slider/quote-slider";
import "./nappy-calculator/nappy-calculator";
// import "./product-animation/product-animation";